<template>
    <checker-detail-row>
        <div slot="left">
            Deposit
        </div>
        <div slot="right">
            <strong>
                <del v-if="shouldShowDiscount">&pound;{{ seasonIntervalData.deposit.was | currencyFormat }}</del>
                <span class="text-green">&pound;{{ quote.deposit | currencyFormat }}</span>
            </strong>
            <small>Due Today</small>
        </div>
    </checker-detail-row>
</template>

<script>
    import CheckerDetailRow from '../CheckerDetailRow';
    import { mapGetters } from 'vuex';
    import storeFormSync from '../../../../store/form-sync';

    export default {
        name: 'deposit-row',

        components: { CheckerDetailRow },

        computed: {
            ...mapGetters('booking', [
                'seasonIntervalData',
            ]),

            ...storeFormSync([
                'booking.reservation_details.bookings[0].quote',
            ]),

            shouldShowDiscount() {
                return this.seasonIntervalData &&
                    this.seasonIntervalData.deposit.was &&
                    this.seasonIntervalData.deposit.was !== this.quote.deposit;
            },
        },
    };
</script>
